<template>
  <div class="main-menu" :class="{'visible': $props.visible, 'desktop': this.isDesktop}" ref="menuContainer" @click="handleDocumentClick">
    <div class="menu-wrapper">
      <button class="menu-close" @click="emitCloseEvent">
        <i class="icon-sc-close"></i>
      </button>
      <ul role="menubar" class="menu-inner">
        <li v-for="(menuItem, index) in $props.navItems" :key="'menuitem'+index" role="menuitem">
          <a :href="menuItem.Url" :target="menuItem.OpenInNewWindow ? '_blank' : null" :class="{'active' : isActiveItem(menuItem)}">{{ menuItem.Name }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'top-navigation-menu',
  data () {
    return {
      isDesktop: true
    }
  },
  props: {
    navItems: {
      type: Array,
      default: () => {
        return []
      }
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitCloseEvent () {
      this.$emit('close-menu')
    },
    handleDocumentClick (e) {
      if (e.target === this.$refs.menuContainer) {
        this.emitCloseEvent()
      }
    },
    handleResize () {
      this.isDesktop = window.innerWidth >= 1260
    },
    isActiveItem (item) {
      return item.IsCurrent && item.Url.indexOf(window.location.pathname.replace(/\//g, '')) > -1
    }
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.handleResize()
    })
    this.$nextTick(() => {
      this.handleResize()
    })
  }
}
</script>

<style scoped lang="scss">
.main-menu {
  position: fixed;
  z-index: map_get($z-index, modal);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  visibility: hidden;
  opacity: 0;
  backdrop-filter: blur(2px);
  overscroll-behavior: contain;
  transition: visibility 200ms 150ms, opacity 200ms 150ms;

  &.desktop {
    transition: none;
  }

  @media (map_get($breakpoints, md)) {
    visibility: visible;
    opacity: 1;
    position: static;
    background-color: transparent;
    backdrop-filter: none;
    transition: visibility 0s, opacity 0s;
  }

  .menu-wrapper {
    width: 100%;
    height: 100%;
    max-width: 265px;
    background-color: $white;
    border-radius: 0 5px 5px 0;
    display: flex;
    flex-direction: column;
    transform: translateX(-100%);
    transition: max-width 200ms, transform 200ms;

    @media (map_get($breakpoints, sm)) {
      max-width: 384px;
    }

    @media (map_get($breakpoints, md)) {
      transform: none;
      max-width: 100%;
      background-color: transparent;
      transition: max-width 0s, transform 0s;
    }

    .menu-close {
      appearance: none;
      outline: none;
      border: none;
      font-size: 1.6rem;
      margin-left: auto;
      margin-top: 2.4rem;
      margin-right: 2.4rem;
      align-self: flex-end;
      color: $dark-grey;

      @media (map_get($breakpoints, sm)) {
        font-size: 2.4rem;
        margin-top: 3.2rem;
        margin-right: 3.2rem;
      }

      @media (map_get($breakpoints, md)) {
        display: none;
      }
    }
  }

  ul.menu-inner {
    display: flex;
    flex-direction: column;
    margin-top: 4rem;

    @media (map_get($breakpoints, sm)) {
      margin-top: 6.4rem;
    }

    @media (map_get($breakpoints, md)) {
      flex-direction: row;
      margin: 0;
      height: 100%;
    }

    li {
      height: 100%;
      padding: 0 2.4rem;

      @media (map_get($breakpoints, sm)) {
        padding: 0 4rem;
      }

      @media (map_get($breakpoints, md)) {
        padding: 0;
        margin: 0 1rem;
      }

      a {
        position: relative;
        padding: 1.6rem 0;
        font-size: 1.5rem;
        font-weight: 600;
        color: $text;
        text-transform: uppercase;
        border-bottom: 1px solid $grey;
        height: 100%;
        max-width: 160px;
        display: flex;
        align-items: center;
        text-decoration: none;
        transition: color 200ms;

        @media (map_get($breakpoints, sm)) {
          padding: 2.4rem 0;
          font-size: 2rem;
          max-width: 260px;
        }

        @media (map_get($breakpoints, md)) {
          font-size: 1.6rem;
          border-bottom: none;
          padding: 0 1rem;
        }

        &:hover, &.active {
          color: $primary;
        }

        &::before {
          position: absolute;
          content: '';
          top: 0;
          left: -2.4rem;
          right: 0;
          width: 2px;
          height: 100%;
          background-color: transparent;
          transition: background-color 200ms;

          @media (map_get($breakpoints, sm)) {
            left: -4rem;
          }

          @media (map_get($breakpoints, md)) {
            left: 0;
            width: 100%;
            height: 3px;
          }
        }

        &.active::before {
          background-color: $primary;
        }
      }
    }
  }

  &.visible {
    visibility: visible;
    opacity: 1;
    transition: visibility 200ms, opacity 200ms;

    .menu-wrapper {
      transform: translateX(0);
      transition: max-width 200ms, transform 200ms 150ms;
    }
  }
}
</style>
